import JSPM              from 'jsprintmanager'
import fmt               from '@/components/mixins/fmt.js'
import api               from '@/api'         
JSPM.JSPrintManager.auto_reconnect = true;
JSPM.JSPrintManager.start();
export default {
  mixins:[fmt],    
  methods: 
    {
      
        async getCBData(customerId)
        {
            const sp       = {'sp'         : 'spCustomerCashBackHistory'}
            const data     = {'customerId' : customerId} 
    
            const json     = Object.assign(data, sp)
            return new  Promise( async (resolve, reject)  =>  {
            await api.post(json).then(res => {
                if(res.status == 200)
              {
               
                
                const data = res.data.recordsets    
                resolve(data)

              }
              else if(res.status==500)
              {
               
                resolve([])
                
    
              } 
              else
              {
                
                resolve([])
              } 
              }).catch(err => 
              {
                
                resolve([])
                
                
              }).finally(() => {
                
              });
            })
    
        },  
      
      printCashBackHistory(text,items)
      {
       
        function jspmWSStatus() {
          if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open)
              return true;
          else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Closed) {
              alert('JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm');
              return false;
          }
          else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Blocked) {
              alert('JSPM has blocked this website!');
              return false;
          }
      }
  
  
  
      const pad        = ' '  
      const GS         = '\x1d'  
      const esc        = '\x1B'; //ESC byte in hex notation
      const newLine    = '\x0A'; //LF byte in hex notation
  
      let cmds         = esc + "@"; //Initializes the printer (ESC @)
      let cols         = 42
      
      //cmds += newLine  
      const header = text.filter(item => item.type == 'H')
      const footer = text.filter(item => item.type == 'F')
      // HEADER 
      header.forEach(row =>{
        
          if(row.order_by == 1)
          {   
              //cols = row.cols   
                        
              cmds += esc + 'a' + '\x01'
              cmds += esc + '!' + '\x38'; //Emphasized + Double-height + Double-width mode selected (ESC ! (8 + 16 + 32)) 56 dec => 38 hex
              cmds += row.text  //text to print
              cmds += newLine;
              
          }
          else
          {
              cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)
              cmds += row.text  //text to print
              cmds += newLine;
          }
          
        
  
      })
      
      
      cmds += newLine   
      cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)   
      cmds += 'SALDO E OPERAZIONI CASHBACK'   //text to print          
      cmds += newLine
      cmds += this.fmtDate()    //text to print          
      let spc = cols - 15        
      cmds += GS + '!' +  '\x01' //Emphasized + Double-height + Double-width mode selected (ESC ! (8 + 16 + 32)) 56 dec => 38 hex
      //cmds += 'SALDO E OPERAZIONI CASHBACK'    //text to print          
      cmds += newLine
      cmds += 'DESCRIZIONE' + pad.repeat(spc) + 'EURO'   //text to print          
      cmds += newLine
      
          
      
      let total = 0
      
      cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)

      const cashback = items[1][0].cashback
      const data = items[0]

      if(data.length > 0)
      {
      
      // BODY
      data.forEach(item => {
            
            //let price = this.fmt1(item.new_cb)
            let price   = this.fmt1(item.cb)
            let product =  item.create_at + ' ' + item.type              
            spc         = cols - product.length - price.length            
            cmds        += product + pad.repeat(spc) +  price   //text to print             
            cmds        += newLine;                    
          
      })
      }
      cmds += newLine;
      
  
     // total = total - subtotal

      
      
      total = this.fmt1(cashback)
      cmds += GS + '!' +  '\x01'

     
      cmds += newLine
      cmds += newLine
     
      spc = cols - spc - total.length
      cmds += "IL TUO CASHBACK E' DI EURO " //text to print

      cmds += newLine
      cmds += newLine
      
      cmds += esc + 'a' + '\x01'
      cmds += esc + '!' + '\x38'; 
      cmds += total   //text to print
      cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)
            
      cmds += newLine
      cmds += newLine
      cmds += newLine
    
      // FOOTER
      footer.forEach(row=>{
  
            cmds += row.text   //text to print
            cmds += newLine
          
  
        
      })
      
      cmds += newLine
      cmds += newLine
      cmds += newLine
      cmds += newLine
      
      cmds += GS + 'V' + '\x01'   
      cmds += newLine
      
    
      if (jspmWSStatus()) {
              //Create a ClientPrintJob
              var cpj = new JSPM.ClientPrintJob();
              cpj.clientPrinter = new JSPM.DefaultPrinter();
              
              /*
              //Set Printer type (Refer to the help, there many of them!)
              if ($('#useDefaultPrinter').prop('checked')) {
                  cpj.clientPrinter = new JSPM.DefaultPrinter();
              } else {
                  cpj.clientPrinter = new JSPM.InstalledPrinter($('#installedPrinterName').val());
              }
              */
              cpj.printerCommands = cmds;
              //Send print job to printer!
              cpj.sendToClient();
              
  
       }
  
  
  



      }
    }
    
}

